/* -------------------------------------------------------------------------- */
/*                        Schema Vehicle Models                               */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const vehicleModel = new schema.Entity('vehicleModels', {}, { idAttribute: 'modelId' });
export const vehicleModels = new schema.Array(vehicleModel);
